(function(){
  'use strict';
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function initReveal(){
    var els=qsa('.oc-reveal,.section,.palo-editorial,.product-carousel,.promotional-banner,.faq-section,.service-cards');
    if(!('IntersectionObserver' in window)){els.forEach(function(el){el.classList.add('is-inview');});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        entry.target.classList.add('is-inview');
        io.unobserve(entry.target);
      });
    },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){io.observe(el);});
  }
  function initStagger(){
    qsa('.product-carousel__track,.oc-editorial__grid,.oc-proof__grid').forEach(function(wrap){
      Array.prototype.forEach.call(wrap.children,function(el,i){
        el.classList.add('oc-reveal'); el.style.setProperty('--oc-delay',(i*75)+'ms');
      });
    });
  }
  function initHero(){}
  function initHeaderScroll(){
    var header=document.querySelector('.site-header');
    if(!header)return;
    var onScroll=function(){header.classList.toggle('is-scrolled',window.scrollY>24);};
    onScroll(); window.addEventListener('scroll',onScroll,{passive:true});
  }
  function init(){
    var runWhenIdle = window.requestIdleCallback
      ? function (fn) { window.requestIdleCallback(fn, { timeout: 1400 }); }
      : function (fn) { window.setTimeout(fn, 750); };
    runWhenIdle(function(){
      document.documentElement.classList.add('oc-reveal-ready');
      initStagger();initReveal();initHeaderScroll();
      setTimeout(function(){qsa('.oc-reveal').forEach(function(el){el.classList.add('is-inview');});},2200);
    });
  }
  document.addEventListener('shopify:section:load',function(){initStagger();initReveal();});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
(function(){
  'use strict';
  function qs(s,c){return (c||document).querySelector(s);}
  function initPremiumProduct(){
    var page=qs('.oc-product-page');
    if(!page)return;
    var form=qs('[data-product-form]',page);
    var sticky=qs('[data-mobile-sticky-atc]');
    var sourceBtn=qs('[data-add-to-cart-btn]',page);
    if(sticky&&sourceBtn){
      var reveal=function(){
         var stickyVisible=window.scrollY>420;
         sticky.classList.toggle('is-visible',stickyVisible);
         document.documentElement.classList.toggle('oc-sticky-atc-active',stickyVisible);
       };
      reveal();window.addEventListener('scroll',reveal,{passive:true});
      var stickyBtn=qs('[data-mobile-sticky-button]',sticky);
      if(stickyBtn)stickyBtn.addEventListener('click',function(){sourceBtn.click();});
    }
    if(form){
      form.addEventListener('click',function(e){
        var btn=e.target.closest('[data-option-value]');
        if(!btn)return;
        var group=btn.closest('.oc-option-group');
        var current=qs('[data-option-current]',group);
        if(current)current.textContent=btn.getAttribute('data-value')||'';
      });
      var dec=qs('[data-quantity-decrease]',form),inc=qs('[data-quantity-increase]',form),input=qs('input[name="quantity"]',form);
      if(dec&&input)dec.addEventListener('click',function(){input.value=Math.max(1,(parseInt(input.value,10)||1)-1);});
      if(inc&&input)inc.addEventListener('click',function(){input.value=(parseInt(input.value,10)||1)+1;});
    }
    var media=qs('.oc-product-media-grid',page);
    if(media && window.matchMedia('(max-width: 749px)').matches){
      var slides=Array.prototype.slice.call(media.querySelectorAll('[data-gallery-slide]'));
      if(slides.length>1){
        var io=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(!entry.isIntersecting)return;
            slides.forEach(function(s){s.classList.remove('is-active');});
            entry.target.classList.add('is-active');
          });
        },{root:media,threshold:.65});
        slides.forEach(function(s){io.observe(s);});
      }
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initPremiumProduct);else initPremiumProduct();
})();
(function(){
  'use strict';
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function initOutcostProductConversion(){
    var form=document.querySelector('.oc-product-form');
    if(!form)return;
    var jsonEl=form.closest('.oc-product-page') && form.closest('.oc-product-page').querySelector('[data-product-json]');
    var stockEl=form.querySelector('[data-stock-note]');
    var stickyPrice=document.querySelector('[data-mobile-sticky-price]');
    if(!jsonEl)return;
    var variants=[];
    try{variants=JSON.parse(jsonEl.textContent);}catch(e){variants=[];}
    function selectedValues(){
      return qsa('.product-form__option',form).map(function(group){
        var selected=group.querySelector('.option-btn.is-selected');
        return selected ? selected.getAttribute('data-value') : null;
      });
    }
    function updateStock(){
      if(!stockEl)return;
      var values=selectedValues();
      var variant=variants.find(function(v){
        var opts=[v.option1,v.option2,v.option3];
        return values.every(function(val,i){return val===null||opts[i]===val;});
      });
      if(!variant){stockEl.textContent='SELECT YOUR OPTIONS';return;}
      if(stickyPrice && variant.price){
        var money=window.themeSettings&&window.themeSettings.moneyFormat;
        if(money){var value=(Number(variant.price)/100).toFixed(2);stickyPrice.textContent=money.replace('{{amount}}',value).replace('{{ amount }}',value);}
      }
      if(!variant.available){stockEl.textContent='SOLD OUT IN THIS SIZE';return;}
      if(variant.inventory_management && Number(variant.inventory_quantity)<=3){stockEl.textContent='ONLY '+Number(variant.inventory_quantity)+' LEFT IN THIS SIZE';return;}
      stockEl.textContent='IN STOCK';
    }
    form.addEventListener('click',function(e){
      if(e.target.closest('[data-option-value]')){setTimeout(updateStock,30);}
    });
    updateStock();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initOutcostProductConversion);else initOutcostProductConversion();
})();
(function(){'use strict';
function initSmartPageLoader(){
var loader=document.querySelector('[data-oc-page-loader]');if(!loader)return;
var showTimer=null;
function show(){clearTimeout(showTimer);loader.classList.add('is-visible');loader.setAttribute('aria-hidden','false');document.documentElement.classList.add('oc-loading')}
function hide(){clearTimeout(showTimer);loader.classList.remove('is-visible');loader.setAttribute('aria-hidden','true');document.documentElement.classList.remove('oc-loading')}
function scheduleShow(delay){clearTimeout(showTimer);showTimer=setTimeout(show,delay)}
function ignoredLink(link,e){
if(!link||link.target==='_blank'||link.hasAttribute('download')||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return true;
if(link.closest('[data-cart-toggle],[data-menu-toggle],[data-menu-close],[data-cart-close],[data-mobile-search-open],[data-mobile-search-close],[data-theme-toggle]'))return true;
var href=link.getAttribute('href')||'';
if(!href||href.charAt(0)==='#'||href.indexOf('mailto:')===0||href.indexOf('tel:')===0||href.indexOf('javascript:')===0)return true;
try{var dest=new URL(href,location.href);return dest.origin!==location.origin}catch(err){return true}
}
hide();
document.addEventListener('click',function(e){
var link=e.target.closest&&e.target.closest('a[href]');
if(!link||e.defaultPrevented||ignoredLink(link,e))return;
scheduleShow(120);
},true);
document.addEventListener('submit',function(e){
var form=e.target;if(!form||form.tagName!=='FORM'||form.target==='_blank')return;
if(form.closest('[data-order-tracking],#pp-tracking-page-app,[id*="parcelpanel"],[class*="parcelpanel"],[id*="cwill"],[class*="cwill"]'))return;
var action=form.getAttribute('action')||location.href;
try{var dest=new URL(action,location.href);if(dest.origin!==location.origin)return}catch(err){return}
scheduleShow(160);
},true);
window.addEventListener('pageshow',hide);
window.addEventListener('beforeunload',show);
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initSmartPageLoader);else initSmartPageLoader();
})();
(function(){
'use strict';
function applyTheme(mode){
  mode=mode==='light'?'light':'dark';
  document.documentElement.setAttribute('data-theme',mode);
  try{localStorage.setItem('outcost-theme-mode',mode);}catch(e){}
  qsa('[data-theme-toggle]').forEach(function(btn){
    btn.setAttribute('aria-label',mode==='dark'?'Switch to light mode':'Switch to dark mode');
    btn.setAttribute('aria-pressed',mode==='light'?'true':'false');
  });
}
function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
function injectThemeStyles(){
  if(document.getElementById('oc-theme-mode-styles'))return;
  var style=document.createElement('style');
  style.id='oc-theme-mode-styles';
  style.textContent="\nhtml[data-theme=\"light\"] body{background:#fff!important;color:#141414!important}\nhtml[data-theme=\"light\"] .main-content{background:#fff;color:#141414}\nhtml[data-theme=\"light\"] .section,html[data-theme=\"light\"] .oc-proof,html[data-theme=\"light\"] .oc-editorial,html[data-theme=\"light\"] .faq-section,html[data-theme=\"light\"] .service-cards{background:#fff;color:#141414}\nhtml[data-theme=\"light\"] .section__heading,html[data-theme=\"light\"] .section__heading--large,html[data-theme=\"light\"] .product-card__title,html[data-theme=\"light\"] .product-section__title{color:#141414}\nhtml[data-theme=\"light\"] .section__see-all,html[data-theme=\"light\"] .product-card__subtitle,html[data-theme=\"light\"] .oc-proof__label{color:#65605c}\nhtml[data-theme=\"light\"] .product-card__image-wrap,html[data-theme=\"light\"] .product-gallery__media{background:#f5f5f4}\nhtml[data-theme=\"light\"] .product-form__option-btn{color:#141414!important;border-color:rgba(0,0,0,.16)!important}\nhtml[data-theme=\"light\"] .product-form__option-btn.is-selected{background:#141414!important;color:#fff!important;border-color:#141414!important}\nhtml[data-theme=\"light\"] .faq-accordion__item{border-color:rgba(0,0,0,.12)!important}\nhtml[data-theme=\"light\"] .palo-editorial__grid{background:#f7f7f5;border-color:rgba(0,0,0,.1)}\nhtml[data-theme=\"light\"] .service-card{background:#f7f7f5!important;color:#141414}\nhtml[data-theme=\"light\"] .oc-marquee{background:#f5f5f4;border-color:rgba(0,0,0,.1)}\nhtml[data-theme=\"light\"] .oc-marquee__item{color:rgba(20,20,20,.8)}\nhtml[data-theme=\"light\"] .oc-mobile-purchase-bar{background:rgba(255,255,255,.94)!important;color:#141414;border-color:rgba(0,0,0,.12)}\nhtml[data-theme=\"light\"] .oc-mobile-purchase-bar *{color:inherit}\nhtml[data-theme=\"light\"] .theme-toggle{color:#141414}\n@media(max-width:749px){html[data-theme=\"light\"] .site-header{background:rgba(255,255,255,.9)}}\n";document.head.appendChild(style);
}
function initThemeToggle(){
  injectThemeStyles();
  var stored=null;
  try{stored=localStorage.getItem('outcost-theme-mode');}catch(e){}
  var fallback=document.documentElement.getAttribute('data-theme-default')||'dark';
  var mode=stored||(fallback==='system'?(window.matchMedia('(prefers-color-scheme: light)').matches?'light':'dark'):fallback);
  applyTheme(mode);
  qsa('[data-theme-toggle]').forEach(function(btn){
    if(btn.dataset.themeModeBound==='1')return;
    btn.dataset.themeModeBound='1';
    btn.addEventListener('click',function(){
      var next=document.documentElement.getAttribute('data-theme')==='light'?'dark':'light';
      applyTheme(next);
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initThemeToggle);else initThemeToggle();
document.addEventListener('shopify:section:load',initThemeToggle);
})();

(function(){
  'use strict';
  function initStickyProductMeta(){
    var sticky=document.querySelector('[data-mobile-sticky-atc]');
    var form=document.querySelector('[data-product-form]');
    var sizeEl=sticky&&sticky.querySelector('[data-mobile-sticky-size]');
    if(!sticky||!form||!sizeEl||sticky.dataset.stickyMetaBound==='1')return;
    sticky.dataset.stickyMetaBound='1';

    function sync(){
      var groups=Array.prototype.slice.call(form.querySelectorAll('.oc-option-group'));
      var sizeGroup=groups.find(function(group){
        var label=group.querySelector('.oc-option-label');
        return label && /size/i.test(label.textContent||'');
      });
      var selected=sizeGroup&&sizeGroup.querySelector('[data-option-value].is-selected');
      sizeEl.textContent=selected ? 'SIZE ' + (selected.getAttribute('data-value')||'').toUpperCase() : 'SIZE —';
    }
    sync();
    form.addEventListener('click',function(e){
      if(e.target.closest('[data-option-value]')) window.setTimeout(sync,20);
    });
    document.addEventListener('shopify:section:load',sync);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initStickyProductMeta);else initStickyProductMeta();
})();
